import { defineCustomElement, timeAgo } from '@mrhenry/wp--custom-elements-helpers';

defineCustomElement( 'mr-timeago', timeAgo() );
